/**
 * FAQ content — HRD-8. Was 5 fixed Q/A pairs baked into the app's ARB files;
 * now server-driven and admin-editable. Bilingual (en/hi, the app's only two
 * supported locales) via parallel columns rather than a translations table.
 *
 *   GET  /faq                — public, mobile-facing: active entries only, sorted
 *   GET  /admin/faq           — admin: every entry, including inactive
 *   POST /admin/faq           — admin: create
 *   PATCH /admin/faq/:id      — admin: update
 *   DELETE /admin/faq/:id     — admin: delete
 */
import { z } from 'zod';
import { UuidSchema } from '../common/id.js';
export const FaqEntrySchema = z.object({
    id: UuidSchema,
    questionEn: z.string().min(1).max(500),
    answerEn: z.string().min(1).max(4000),
    questionHi: z.string().min(1).max(500),
    answerHi: z.string().min(1).max(4000),
    sortOrder: z.number().int(),
    active: z.boolean(),
});
// ── GET /faq ─────────────────────────────────────────────────────────────
export const FaqListResponse = z.object({
    entries: z.array(FaqEntrySchema),
});
// ── GET /admin/faq ───────────────────────────────────────────────────────
export const AdminFaqListResponse = z.object({
    entries: z.array(FaqEntrySchema),
});
// ── POST /admin/faq ──────────────────────────────────────────────────────
export const FaqCreateBody = z.object({
    questionEn: z.string().min(1).max(500),
    answerEn: z.string().min(1).max(4000),
    questionHi: z.string().min(1).max(500),
    answerHi: z.string().min(1).max(4000),
    sortOrder: z.number().int().default(0),
    active: z.boolean().default(true),
});
// ── PATCH /admin/faq/:id ─────────────────────────────────────────────────
export const FaqUpdateBody = z.object({
    questionEn: z.string().min(1).max(500).optional(),
    answerEn: z.string().min(1).max(4000).optional(),
    questionHi: z.string().min(1).max(500).optional(),
    answerHi: z.string().min(1).max(4000).optional(),
    sortOrder: z.number().int().optional(),
    active: z.boolean().optional(),
});
//# sourceMappingURL=faq.js.map